// extracted by mini-css-extract-plugin
module.exports = {"headline":"dining_desktop_headline__2L28s","information":"dining_desktop_information__2Ck3u"};